// Plan & Billing unter /settings/plan. Kunden mit Plan-Payment (preview und
// enforced) und Admin-Simulationen sehen PlanOverview, alle anderen den
// heutigen Stand in LegacyPaymentPlan (D6).
//
// Solange das Plan-Feld noch lädt, steht mode vorläufig auf legacy, obwohl
// ein Plan-Payment da sein kann. Dann zeigt die Seite kurz einen Ladezustand,
// sonst blitzte bei migrierten Kunden die alte Ansicht auf. Auf Stages ohne
// Plan-Feld ist planFieldSettled immer true, dort ändert sich nichts.
import { useTranslation } from 'react-i18next'

import { MODES } from '../../features/pricing/entitlements'
import { useEntitlements } from '../../features/pricing/hooks'
import SEO from '../seo'
import LegacyPaymentPlan from './payment-plan/legacy-payment-plan'
import PlanOverview from './payment-plan/plan-overview'
import SettingsContainer from './settings-container'

/** PlanOverview bei Plan-Payment, echt oder simuliert */
export const showsPlanOverview = (entitlements) =>
  !!entitlements &&
  (entitlements.mode !== MODES.LEGACY || !!entitlements.isSimulated)

/** Plan-Feld lädt noch, ein Plan-Payment ist noch nicht erkennbar */
export const isPlanPending = (entitlements) =>
  !!entitlements &&
  entitlements.planFieldSettled === false &&
  !showsPlanOverview(entitlements)

const PlanPending = () => {
  const { t } = useTranslation()

  return (
    <SettingsContainer
      title={t('components.settings.payment_plan.title')}
      description={t('components.settings.payment_plan.description')}
    >
      <SEO title={t('seo.titles.settings_planbilling')} />
      <div aria-busy='true' className='animate-pulse space-y-3'>
        <div className='h-4 w-40 rounded bg-gray-200' />
        <div className='h-4 w-64 rounded bg-gray-200' />
        <div className='h-4 w-52 rounded bg-gray-200' />
      </div>
    </SettingsContainer>
  )
}

const ActualPaymentPlan = () => {
  const entitlements = useEntitlements()

  if (showsPlanOverview(entitlements)) return <PlanOverview />
  if (isPlanPending(entitlements)) return <PlanPending />

  return <LegacyPaymentPlan />
}

export default ActualPaymentPlan
